const pad = (value: number) => String(value).padStart(2, "0");

export const getProspectHour = (prospect?: Partial<EasyTech.Prospect>) => {
  if (prospect?.hour) return prospect.hour.slice(0, 5);

  if (!prospect?.date) return "";

  const date = new Date(prospect.date);
  if (Number.isNaN(date.getTime())) return "";

  return `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
};

export const getProspectDateTimeLocalValue = (prospect?: Partial<EasyTech.Prospect>) => {
  if (!prospect?.date) return "";

  const date = new Date(prospect.date);
  if (Number.isNaN(date.getTime())) return "";

  const hours = prospect?.hour?.split(":")[0] ?? "00";
  const minutes = prospect?.hour?.split(":")[1] ?? "00";

  return [
    date.getUTCFullYear(),
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
  ].join("-") + `T${hours}:${minutes}`;
};

export const buildProspectPayload = (prospect: EasyTech.Prospect): EasyTech.Prospect => {
  const { ref, ...payload } = prospect as EasyTech.Prospect;
  const formattedPayload = payload as EasyTech.Prospect;

  if (formattedPayload.date) {
    const visitDate = new Date(formattedPayload.date);
    if (!Number.isNaN(visitDate.getTime())) {
      formattedPayload.date = new Date(Date.UTC(
        visitDate.getUTCFullYear(),
        visitDate.getUTCMonth(),
        visitDate.getUTCDate(),
        0,
        0,
        0,
        0
      )).toISOString();
    }
  }

  const hour = getProspectHour(formattedPayload);
  if (hour) {
    formattedPayload.hour = hour;
  }

  const customerLatitude = formattedPayload.customer?.address?.latitude;
  const customerLongitude = formattedPayload.customer?.address?.longitude;
  if (formattedPayload.location?.latitude !== undefined && formattedPayload.location?.longitude !== undefined) {
    formattedPayload.location = {
      latitude: formattedPayload.location.latitude,
      longitude: formattedPayload.location.longitude,
      type: "LOCATION",
    };
  } else if (customerLatitude !== undefined && customerLongitude !== undefined) {
    formattedPayload.location = {
      latitude: customerLatitude,
      longitude: customerLongitude,
      type: "CUSTOMER",
    };
  }

  return formattedPayload;
};
